import React, { useRef } from "react";
// images and svg
import SubArrow from "../../../assets/images/dashboard/chevrons-right.svg";
import PhonePluse from "../../../assets/images/phoneplus.svg";
import NormalButton from "../NormalButton/NormalButton";
import { history } from "../../../helpers/index";
import CommonCheckBox from "../CheckBox/CommonCheckBox";
import shareIcon from "../../../assets/icons/shareIcon.svg";
import downloadIcon from "../../../assets/icons/downloadIcon.svg";
import "./style.scss";
const Title = ({
  title,
  subtitle,
  subtitle1,
  authName = false,
  subtitle2,
  phoneNumber = false,
  type = false,
  ViewStorageLists = false,
  isCommodityDeposits,
  isAssignAgent,
  isCustomer,
  isTeamMember,
  handlecustomerNavigate,
  isMarkActive,
  checkBoxLabel = "",
  handleCheckBoxChange,
  isChecked,
  isTicket,
  isSubmittedRequest,
  commonBtnlabel = "",
  commonBtndisabled = false,
  handlecommonNavigate,
  iscommonBtn,
  isTransaction,
  onClick,
  buttonLabel,
  titleDirection,
  subTitleDirection,
  isRaiseTicket,
  setTicketModal,
  isCluster,
  isBDE,
  isCommodities,
  isShareDownload,
  subTitleDirection1,
  handleDownload,
  handleShare,
  tenureToDate = false,
  isPurchase = false,
  isGrainManager = false
}) => {
  return (

    <div
      className={
        subtitle
          ? " common-title d-flex flex-md-row flex-column gap-3 gap-md-0 align-items-end  align-items-md-center justify-content-between  px-md-5"
          : `common-subtitle d-flex ${isGrainManager ? "flex-md-row flex-column align-items-end gap-3" : "align-items-center"} justify-content-md-between justify-content-end px-md-5 px-3`
      }
    >
      <div className="d-md-flex d-none flex-md-row flex-column align-items-md-center align-items-start">
        <span
          onClick={() => {
            if (subtitle1 && subTitleDirection1) {
              // Handle going back from subtitle1
              subTitleDirection1(false);
            } else if (subtitle && subTitleDirection) {
              // Handle going back from subtitle
              subTitleDirection(false);
            } else if (title && titleDirection) {
              // Handle going back from title   
              titleDirection(false);
            }
          }}
          className="p-0 me-3"
          style={{ fontSize: "1.3rem", fontWeight: "bold", cursor: "pointer" }}
        >
          &#8592;
        </span>

        <span onClick={titleDirection} className={`${titleDirection && window.innerWidth <= 768 ? "text-decoration-underline" : ""} cursor-pointer tittlemy`}>
          {title}
        </span>{" "}
        {subtitle && (
          <div
            className={subtitle1 ? "common-title p-0" : "common-subtitle1 p-0"}
          >
            {"  "}
            {window?.innerWidth > 600 && <>&nbsp;</>}
            <img src={SubArrow} alt={subtitle} className="d-none d-md-block" />{" "}
            <span
              onClick={subTitleDirection}
              className={`${subTitleDirection && window.innerWidth <= 768 ? "text-decoration-underline fw-500" : ""} cursor-pointer subTitle`}
            >
              {" "}
              {subtitle}
            </span>
          </div>
        )}
        {subtitle1 && (
          <div
            className={subtitle2 ? "common-title p-0" : "common-subtitle1 p-0"}
          >
            {"  "}
            {window?.innerWidth > 600 && <>&nbsp;</>}
            <img src={SubArrow} alt={subtitle1} className="d-none d-md-block" />{" "}
            <span
              onClick={subTitleDirection1}
              className={`${subTitleDirection1 && window.innerWidth <= 768 ? "text-decoration-underline fw-500" : ""} cursor-pointer subTitle1`}
            >
              {" "}
              {subtitle1}
            </span>
          </div>
        )}
        {subtitle2 && (
          <div className="common-subtitle1 p-0">
            {"  "}
            {window?.innerWidth > 600 && <>&nbsp;</>}
            <img src={SubArrow} alt={subtitle2} className="d-none d-md-block" />{" "}
            <span className="subTitle2"> {subtitle2}</span>
          </div>
        )}
      </div>
      {ViewStorageLists && (
        <div className="dashboard_ViewStorage_Btn">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"View Storage Lists"}
          // onClick={handleSubmit(onSubmit)}
          />
        </div>
      )}
      {isCommodityDeposits && (
        <div className="dashboard_ViewStorage_Btn col-12">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Create commodity deposit"}
            onClick={() =>
              history.push("/admin/commodity-deposits/create-commodity-deposit")
            }
          />
        </div>
      )}
      {isSubmittedRequest && (
        <div className="dashboard_ViewStorage_Btn">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"View Proposal"}
            onClick={() =>
              history.push(
                "/admin/value-chain-management/submitted-requests/view-proposals"
              )
            }
          />
        </div>
      )}
      {isTeamMember && (
        <div className="dashboard_ViewStorage_Btn">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Add New Member"}
            onClick={() =>
              history.push({
                pathname: "/admin/team-members/create-team-member",
                state: { edit: false, role: "Team-Member" },
              })
            }
          />
        </div>
      )}
      {isCustomer && (
        <div className="dashboard_ViewStorage_Btn px-3 px-md-0 pt-1">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Add New Customer"}
            onClick={handlecustomerNavigate}
          />
        </div>
      )}
      {isCluster && (
        <div className="dashboard_ViewStorage_Btn px-3 px-md-0 pt-1">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Add New Cluster Manager"}
            onClick={() =>
              history.push({
                pathname:
                  "/admin/onboardings/cluster-manager/add-cluster-manager",
                state: { role: "Cluster Manager" },
              })
            }
          />
        </div>
      )}
      {isBDE && (
        <div className="dashboard_ViewStorage_Btn px-3 px-md-0 pt-1">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Add New BDE"}
            onClick={() =>
              history.push({
                pathname: "/admin/onboardings/bde/add-bde",
                state: { role: "BDE" },
              })
            }
          />
        </div>
      )}
      {isCommodities && (
        <div className="dashboard_ViewStorage_Btn px-3 px-md-0 pt-1">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={"Add New Commodities"}
            onClick={() =>
              history.push("/admin/onboardings/commodities/add-commodities")
            }
          />
        </div>
      )}
      {isTicket && (
        <div className="dashboard_ViewStorage_Btn">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={isRaiseTicket ? "Raise new Ticket" : "Add New Ticket"}
            onClick={() =>
              isRaiseTicket ? setTicketModal(true) : handlecustomerNavigate
            }
          />
        </div>
      )}
      {iscommonBtn && (
        <>
          <div className={`${subtitle ? "px-3 px-md-0 pt-2 pt-md-0" : ""} dashboard_ViewStorage_Btn`}>
            {!tenureToDate ? (
              <NormalButton
                className="orderBtn ViewStorage_Btn"
                label={commonBtnlabel}
                onClick={handlecommonNavigate}
                type="button"
                disabled={commonBtndisabled}
              />
            ) : (
              <small className="blink">Tenure To Date crossed</small>
            )}
          </div>
        </>
      )}
      {isMarkActive && (
        <div className="d-flex align-items-center dashboard_ViewStorage_Btn">
          <CommonCheckBox
            isChecked={isChecked}
            // markactive={true}
            name="agree"
            onChange={handleCheckBoxChange}
          />
          <span className="ms-2 text-dark fs-6 ">{checkBoxLabel}</span>
        </div>
      )}
      {isAssignAgent && (
        <div
          onClick={() => history.push("/admin/commodity-deposits/assign-agent")}
          className="dashboard_ViewStorage_Btn"
        >
          <h6 className="mt-2">Assign to agent</h6>
        </div>
      )}
      {isTransaction && (
        <div className="dashboard_ViewStorage_Btn">
          <NormalButton
            className="orderBtn ViewStorage_Btn"
            label={buttonLabel || "View History"}
            onClick={onClick}
          />
        </div>
      )}
      {isShareDownload && (

        <div className="dashboard_ViewStorage_Btn px-3 px-md-0 pt-1">
          <div className="mt-2">
            <img
              src={shareIcon}
              alt="shareIcon"
              className="me-3 icon-res cursor-pointer"
              onClick={handleShare}
            />
            <img
              src={downloadIcon}
              alt="download"
              className="icon-res cursor-pointer"
              onClick={handleDownload}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Title;
